module.exports = __webpack_public_path__ + "static/media/reference-slider-8.aeacbba4.jpg";